var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 4C10.5362 4 10.1667 4.28431 10.1667 4.8V5.6H14.8333V4.8C14.8333 4.28431 14.4638 4 14.1667 4H10.8333ZM16.8333 5.6V4.8C16.8333 3.32747 15.7105 2 14.1667 2H10.8333C9.2895 2 8.16667 3.32747 8.16667 4.8V5.6H5C4.44772 5.6 4 6.04772 4 6.6C4 7.15228 4.44772 7.6 5 7.6H5.66667V19.2C5.66667 20.6725 6.7895 22 8.33333 22H16.6667C18.2105 22 19.3333 20.6725 19.3333 19.2V7.6H20C20.5523 7.6 21 7.15228 21 6.6C21 6.04772 20.5523 5.6 20 5.6H16.8333ZM7.66667 7.6V19.2C7.66667 19.7157 8.03622 20 8.33333 20H16.6667C16.9638 20 17.3333 19.7157 17.3333 19.2V7.6H7.66667ZM10.8333 10.1C11.3856 10.1 11.8333 10.5477 11.8333 11.1V16.5C11.8333 17.0523 11.3856 17.5 10.8333 17.5C10.281 17.5 9.83333 17.0523 9.83333 16.5V11.1C9.83333 10.5477 10.281 10.1 10.8333 10.1ZM14.1667 10.1C14.719 10.1 15.1667 10.5477 15.1667 11.1V16.5C15.1667 17.0523 14.719 17.5 14.1667 17.5C13.6144 17.5 13.1667 17.0523 13.1667 16.5V11.1C13.1667 10.5477 13.6144 10.1 14.1667 10.1Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.fc27fd398966ec38f56cf18714e6fd79.svg";